import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Link from 'components/shared/Link';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

const propTypes = {
  active: PropTypes.bool,
  to: PropTypes.string,
};

const defaultProps = {
  active: false,
  to: undefined,
};

function TabLink({ active, to, ...props }) {
  if (active) return <StyledSpan {...props} />;
  return <StyledLink to={to} {...props} />;
}

const style = css`
  text-decoration: none;
  font-size: var(--font-size-xs);
  color: var(--color-primary);
  transition: all 0.2s;
  &:hover {
    text-decoration: none;
    color:var(--color-secondary);
  }
`;

const StyledLink = styled(NavLink)`
  ${style};
`;

const StyledSpan = styled.span`
  ${style};
  color:var(--color-secondary);
`;

TabLink.propTypes = propTypes;
TabLink.defaultProps = defaultProps;

export default TabLink;
